import type { FC } from 'react'
import { H3 } from '../../compass-ui'
import BaseModal from '../BaseModal'
import Accordion, { type AccordionTabProps } from '../Accordion'

interface FAQModalProps {
  open: boolean
  toggleModalOpen: (value: boolean) => void
  data: AccordionTabProps[]
  id: string
  labelledBy: string
  describedBy: string
}

const FAQModal: FC<FAQModalProps> = ({
  open,
  toggleModalOpen,
  id,
  labelledBy,
  describedBy,
  data,
}) => (
  <BaseModal
    open={open}
    onClose={() => toggleModalOpen(false)}
    aria-labelledby={labelledBy}
    aria-describedby={describedBy}
  >
    <div className="flex flex-col" id={id} data-testid={id}>
      <H3 className="mb-2">Frequently asked questions</H3>
      <Accordion tabInfo={data} />
    </div>
  </BaseModal>
)

export default FAQModal
